import { render, staticRenderFns } from "./InputUserPhone.vue?vue&type=template&id=637b37b4&scoped=true&"
import script from "./InputUserPhone.vue?vue&type=script&lang=js&"
export * from "./InputUserPhone.vue?vue&type=script&lang=js&"
import style0 from "./InputUserPhone.vue?vue&type=style&index=0&id=637b37b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b37b4",
  null
  
)

export default component.exports